/** Links de pago (checkout) de cada oferta. */
export const checkoutLinks = {
  megapack: 'https://www.todopackdigital.store/checkout/megapack-seno-jardin',
  megapack360: 'https://www.todopackdigital.store/checkout/megapack-seno-jardin-360',
} as const
